'use strict';

var React = require('react');

var SvgInventoryFilledMajor = function SvgInventoryFilledMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M8.77 3.406a2.25 2.25 0 0 1 2.46 0l3.569 2.328a3.75 3.75 0 0 1 1.701 3.141v6.875c0 .69-.56 1.25-1.25 1.25h-10.5c-.69 0-1.25-.56-1.25-1.25v-6.875a3.75 3.75 0 0 1 1.702-3.141l3.569-2.328Zm2.73 4.594a.5.5 0 0 0-.5-.5h-2a.5.5 0 0 0-.5.5v2.5a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5v-2.5Zm-2 4.5a.5.5 0 0 0-.5-.5h-2a.5.5 0 0 0-.5.5v2.5a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5v-2.5Zm3.5-.5a.5.5 0 0 1 .5.5v2.5a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-2.5a.5.5 0 0 1 .5-.5h2Z"
  }));
};
SvgInventoryFilledMajor.displayName = "InventoryFilledMajor";

exports.SvgInventoryFilledMajor = SvgInventoryFilledMajor;
